import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerAreaContainerComponent } from '../../containers/customer-area-container/customer-area-container.component';
import { PaymentsListComponent } from './components/payments-list/payments-list.component';
import { TokenLocalStorageService } from '../authentication/services/token-local-storage.service';

const routes: Routes = [
  {
    path: '', component: CustomerAreaContainerComponent,
    children: [
      {path: 'paiements', children: [
          { path: '', component: PaymentsListComponent, canActivate: [TokenLocalStorageService] },
          { path: ':tab/:procedure', pathMatch: 'full', component: PaymentsListComponent, canActivate: [TokenLocalStorageService] },
          { path: ':tab', component: PaymentsListComponent, canActivate: [TokenLocalStorageService] },
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaymentsRoutingModule { }
